const alertItemsDefaultState = {
    data: [],
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    errorMessage: null
};

const alertItemsReducer = (state = alertItemsDefaultState, action) => {
    switch (action.type) {
        case 'START_GET_ALERT_ITEMS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_ALERT_ITEMS_SUCCESS':
            return {
                ...state,
                data: action.alerts,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'START_REMOVE_ALERT_ITEMS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'ALERT_ITEM_DELETE_SUCCESS':
            return {
                ...state,
                data: state.data.filter(alertItemId => alertItemId !== action.alertItemId),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your Alert Item have been removed!',
            };
        case 'ALERT_ITEM_CLEAR_SUCCESS':
            return {
                ...state,
                success: false
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default alertItemsReducer;